import { CircleStackIcon, CodeBracketIcon } from "@heroicons/react/24/outline";

const buttons = [
  {
    text: "Dataset",
    icon: <CircleStackIcon className="w-5 h-5" />,
    url: "https://github.com/autorespec/AutoReSpec/tree/main/AutoReSpecBench",
  },
  {
    text: "Code",
    icon: <CodeBracketIcon className="w-5 h-5" />,
    url: "https://github.com/autorespec/AutoReSpec",
  },
];

export default function Header() {
  return (
    <header className="text-center py-12 px-4 bg-white space-y-6">
      <h1 className="text-4xl sm:text-5xl font-bold leading-tight">
        AutoReSpec Leaderboard
      </h1>

      <div className="flex flex-wrap justify-center gap-4 pt-4">
        {buttons.map((btn) => (
          <a
            key={btn.text}
            href={btn.url}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-4 py-2 rounded-full bg-gray-800 text-white shadow hover:scale-105 transition-transform"
          >
            <span className="mr-2">{btn.icon}</span>
            {btn.text}
          </a>
        ))}
      </div>
    </header>
  );
}
